<template>
  <div class='animated fadeIn'>
    <b-card no-body>
      <b-card-header>
        <i class='fa fa-list mr-2'></i>
        <strong>Liste des catégories</strong>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns='columns' :data='items' :options='options'>
          <div slot="action" slot-scope="props">
            <b-button
              type="button"
              @click.prevent="destroy(props.row.id)"
              class="badge badge-danger mr-3 p-2"
            >
              <i class="fa fa-remove"></i> Supprimer
            </b-button>
            <b-button
              type="button"
              @click="editCategorie('edit', props.row.id)"
              class="badge badge-primary p-2"
            >
              <i class="fa fa-edit"></i> Modifier
            </b-button>
          </div>
          <div v-if="props.row.created_at" slot="created_at" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ formatDate(props.row.created_at) }}</span>
          </div>
        </v-client-table>
      </b-card-body>
      <div slot="footer">
        <b-button
          type="button"
          @click="editCategorie('add')"
          class="pull-right"
          size="md"
          variant="primary"
        >
          <i class="fa fa-plus"></i> Ajouter une catégorie
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../utils/auth'

export default {
  data() {
    return {
      columns: ['created_at', 'libelle', 'libelle_technique', 'action'],
      items: [],
      options: {
        headings: {
          libelle: 'Libelle',
          libelle_technique: 'Libellé technique',
          created_at: 'Date de création',
          action: 'Action'
        },
        sortable: ['libelle'],
        filterable: ['libelle'],
        perPage: 10,
        perPageValues: [10, 25, 50],
        texts: {
          filterPlaceholder: 'Libellé'
        },
        orderBy: { column: 'created_at', ascending: false }
      }
    }
  },
  mounted() {
    this.all()
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json'
    this.$axios.defaults.headers.common['Provider'] = getProvider()
  },
  methods: {
    all() {
      let self = this;
      this.$store.commit('IS_LOADING', true);
      this.$axios
        .get('/administration/categories')
        .then(response => {
          this.$store.commit('IS_LOADING', false);
          this.items = response.data.categories;
        })
        .catch(function(error) {
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Un problème est survenu, merci de contacter l\'administrateur',
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    editCategorie(to, id) {
      if (to === "edit") {
        this.$router.push({ path: "/administration/categories/edit/" + id });
      } else if (to === "add") {
        this.$router.push({ path: "/administration/categories/add" });
      }
    },
    destroy(id) {
      let self = this
      this.$swal.fire({
        title: 'Êtes-vous sûr?',
        text: "Voulez-vous vraiment supprimer cette catégorie ?",
        type: 'warning',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonColor:"#ff1744",
        confirmButtonText: 'Annuler',
        cancelButtonText: 'Supprimer',
      }).then((result) => {
        if (!result.value) {
          this.$store.commit('IS_LOADING', true)
          this.$axios
            .post("/administration/categories/delete/" + id)
            .then(response => {
              this.$store.commit('IS_LOADING', false)
              this.$swal({ position: 'top', type: 'success', title:'Suppression avec succès', text:'La catégorie a bien été supprimée',showConfirmButton: false, timer: 5000})
              this.all()
            })
            .catch(function(error){
              self.$store.commit('IS_LOADING', false)
              self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Un problème est survenu, merci de contacter l\'administrateur',showConfirmButton: false, timer: 5000})
            })
        }
      })
    },
    formatDate(textDate) {
      let date =
        textDate !== null
          ? new Date(textDate).toLocaleDateString("fr-FR")
          : "-";
      return date;
    }
  }
}
</script>

<style>

</style>
